import { render, staticRenderFns } from "./PODocumentSent.vue?vue&type=template&id=233d4ca4&"
import script from "./PODocumentSent.vue?vue&type=script&lang=js&"
export * from "./PODocumentSent.vue?vue&type=script&lang=js&"
import style0 from "./PODocumentSent.vue?vue&type=style&index=0&id=233d4ca4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports